var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex flex-col"},[_c('Header',{attrs:{"show-close-chat":true}}),_c('FinishedChat',{on:{"close-chat-window":_vm.close,"start-new":_vm.startNew}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }